module.exports = __webpack_public_path__ + "media/pick_four.1247f216.mp3";